import type { NotificationRecipients } from '@axilon-apps/domains-ontology-ui-state'

/** Org roles a rule or agent can address (proxy `notifications.RecipientRoles`). */
export const RECIPIENT_ROLES = ['viewer', 'operator', 'maintenance', 'engineer', 'admin'] as const

/** Fills missing lists and drops duplicates so equality checks are stable. */
export function normalizeRecipients(
  value: NotificationRecipients | undefined
): NotificationRecipients {
  return {
    user_ids: [...new Set(value?.user_ids ?? [])],
    roles: [...new Set(value?.roles ?? [])]
  }
}

export function sameRecipients(
  a: NotificationRecipients | undefined,
  b: NotificationRecipients | undefined
): boolean {
  const x = normalizeRecipients(a)
  const y = normalizeRecipients(b)
  const same = (p: string[], q: string[]) =>
    p.length === q.length && [...p].sort().join('\n') === [...q].sort().join('\n')
  return same(x.user_ids, y.user_ids) && same(x.roles, y.roles)
}

/** Loose shape check for an outside email address typed into a form. */
export function isLikelyEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}
